<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div formArrayName="ownerProfessionDetails">
                @for (
                  ownerProfessionDetail of ownerProfessionDetails.controls;
                  track ownerProfessionDetail;
                  let i = $index
                ) {
                  <div class="quotite-container mt-1" [formGroupName]="i">
                    <pr-input-owner
                      formControlName="ownerId"
                      [multiple]="false"
                      [disabled]="true"
                      [derrors]="derrors"
                    ></pr-input-owner>
                    @if (optionsProfessionSocialRegime.length > 0) {
                      <div class="row">
                        <div class="col-md-12">
                          <pr-input-column
                            label="Régime social"
                            [derrors]="derrors"
                          >
                            <mat-select formControlName="socialRegime">
                              @for (
                                option of optionsProfessionSocialRegime;
                                track option
                              ) {
                                <mat-option [value]="option.id">
                                  {{ option.value }}
                                </mat-option>
                              }
                            </mat-select>
                          </pr-input-column>
                        </div>
                      </div>
                    }
                    @if (optionsProfessionCategory.length > 0) {
                      <div class="row">
                        <div class="col-md-12">
                          <pr-input-column
                            label="Catégorie professionnelle"
                            [derrors]="derrors"
                          >
                            <mat-select formControlName="professionalCategory">
                              @for (
                                option of optionsProfessionCategory;
                                track option
                              ) {
                                <mat-option [value]="option.id">
                                  {{ option.value }}
                                </mat-option>
                              }
                            </mat-select>
                          </pr-input-column>
                        </div>
                      </div>
                    }
                    @if (
                      optionsProfessionCategorySub.length > 0 &&
                      getFilteredSubCategory(
                        ownerProfessionDetail.get('professionalCategory').value
                      ).length > 0
                    ) {
                      <div class="row">
                        <div class="col-md-12">
                          <pr-input-column
                            label="Profession médicale"
                            [derrors]="derrors"
                          >
                            <mat-select
                              formControlName="professionalCategorySub"
                            >
                              @for (
                                option of getFilteredSubCategory(
                                  ownerProfessionDetail.get(
                                    'professionalCategory'
                                  ).value
                                );
                                track option
                              ) {
                                <mat-option [value]="option.id">
                                  {{ option.value }}
                                </mat-option>
                              }
                            </mat-select>
                          </pr-input-column>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
